// Server-Kopie der Funnel-Schritte vor der Zahlung (08.10.2026).
//
// GTM sieht „Angebot gesehen“ und „Bezahlfenster geöffnet“ nur im Browser und nur ohne
// Ad-Blocker. Die Datenbank endete bisher beim fertigen Lauf, deshalb ließ sich der Schritt
// von der Ergebnisliste zur Zahlung nicht je Nutzer auszählen. POST /api/prism/event schreibt
// die vier Schritte als productEvents mit (userId + prismRunId, keine Freitexte). Sie können
// sich je Lauf wiederholen (Neuladen, Rückkehr von Stripe): beim Auswerten je Nutzer und
// Lauf einmal zählen.
//
// Fire-and-forget wie pushDataLayer: nie awaiten, nie in den Funnel werfen.

const PRISM_EVENT_URL = '/api/prism/event';

export type PrismServerEvent =
  | 'prism_results_viewed'
  | 'prism_offer_details_viewed'
  | 'prism_checkout_opened'
  | 'prism_payment_submitted'
  // Im Bezahlfenster: erste Eingabe ins Rechnungsformular, Zahlungsfelder geladen,
  // Zahlung oder ihr Laden fehlgeschlagen (mit fester Fehlerkennung).
  | 'prism_checkout_form_started'
  | 'prism_payment_ready'
  | 'prism_payment_failed'
  // Prism-Umsatzpaket (16.10.2026). `kind` = feste Unterart (API prüft gegen eine Liste).
  | 'prism_dm_teaser_shown' // kind: E-Mail-Stand (verified | probable | found | none)
  | 'prism_dm_teaser_opened'
  | 'prism_dm_teaser_none' // kind: none | failed
  | 'prism_card_hint_opened'
  | 'prism_website_hint' // kind: own_product | ai_chat | social | redirect
  | 'prism_target_notice' // kind: local_b2c | outside_dach
  | 'prism_wallet_selected' // kind: apple_pay | google_pay
  // Gratis-Leads vor dem Kauf: gezeigt (count), kopiert (kind email|phone|all), exportiert,
  // keine (kind none|used), „Name + E-Mail freischalten“ an einer Hinweis-Zeile.
  | 'prism_free_leads_shown'
  | 'prism_free_lead_copied'
  | 'prism_free_leads_exported'
  | 'prism_free_leads_none'
  | 'prism_unlock_hint_clicked';

/**
 * Von wo der Schritt ausgelöst wurde: Kauf-Knopf der Ergebnisliste, gesperrter Ansprechpartner
 * in der Liste, Angebotsseite, deren Klebeleiste.
 */
export type PrismEventFrom = 'results' | 'lead' | 'offer' | 'sticky';

export function sendPrismEvent(
  name: PrismServerEvent,
  prismRunId: string | null | undefined,
  from?: PrismEventFrom,
  /** Nur prism_payment_failed: grober Grund aus fester Liste (`validation`, `declined`, …). */
  code?: string,
  /** Feste Unterart der Ereignisse vom 16.10.2026 (s. PrismServerEvent). */
  kind?: string,
  /** Nur prism_free_leads_shown: Zahl der gezeigten Gratis-Leads. */
  count?: number,
): void {
  try {
    void fetch(PRISM_EVENT_URL, {
      method: 'POST',
      credentials: 'include',
      // keepalive: der Klick auf „Bezahlen“ kann die Seite verlassen (Redirect-Checkout).
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name,
        ...(prismRunId ? { prismRunId } : {}),
        ...(from ? { from } : {}),
        ...(code ? { code } : {}),
        ...(kind ? { kind } : {}),
        ...(typeof count === 'number' ? { count } : {}),
      }),
    }).catch(() => {
      // Messung darf den Funnel nie stören.
    });
  } catch {
    // dito (z. B. fetch nicht verfügbar)
  }
}
